import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Typography, Icon } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  actionText: {
    color: theme.palette.secondary.main,
  },
}))

const IconLinkButton = (props) => {
  const classes = useStyles()
  return (
    <Typography
      className={clsx(
        classes.actionText,
        'p-8 text-xs font-semibold cursor-pointer flex items-center',
      )}
      onClick={props.onClick}
    >
      <Icon
        fontSize="small"
        className={props.children ? 'ltr:mr-4 rtl:ml-4' : null}
      >
        {props.icon}
      </Icon>
      {props.children}
    </Typography>
  )
}

export default IconLinkButton
